<!--
 - Order adjustments component
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2025 Build Centrix
 -->
<div class="manage-adjustments">
  <bc-templates-modal-layout
    [isLoading]="isLoading"
    [loadingText]="('actions.loading'|translate)"
    (onCloseButtonClicked)="onDismiss()"
  >
    <!--Dialog Title-->
    <div title-content>
      {{ title }}
    </div>
    <!--Dialog Content-->
    <div body-content>
      <!--Content-->
      <div class="bcx-modal-content">
        <!--Order Adjustments-->
        <div class="bcx-modal-content-container">
          <!--&& assignmentOptions?.length > 0-->
          <form #adjustmentsForm="ngForm">
            <div class="row">
              <!--Label  -->
              <div class="col-sm-4">
                <bc-atoms-input-group
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.label.title' | translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.label.description'|translate}}"
                  [required]="true"
                  [state]="labelControl.status"
                  [stateInput]="labelControl.errors"
                  [stateTrigger]="labelControl.invalid && (labelControl.dirty)"
                >
                  <bc-atoms-input
                    id="adjustmentLabel"
                    name="adjustmentLabel"
                    title="{{'order.fulfillment.groups.adjustments.fields.label.title'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.label.description'|translate}}"
                    size="small"
                    [required]="true"
                    [disabled]="isLoading"
                    [(model)]="adjustment.label"
                    [(ngModel)]="adjustment.label"
                    #labelControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Description-->
              <div class="col-sm-8">
                <bc-atoms-input-group
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.description.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.description.description'|translate}}"
                  [required]="false"
                  [state]="descriptionControl.status"
                  [stateInput]="descriptionControl.errors"
                  [stateTrigger]="descriptionControl.invalid && (descriptionControl.dirty)"
                >
                  <bc-atoms-input
                    id="adjustmentDescription"
                    name="adjustmentDescription"
                    title="{{'order.fulfillment.groups.adjustments.fields.description.title'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.description.description'|translate}}"
                    size="small"
                    [required]="false"
                    [disabled]="isLoading"
                    [(model)]="adjustment.description"
                    [(ngModel)]="adjustment.description"
                    #descriptionControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Fulfillment Group-->
              <div
                [ngClass]="{ 'col-sm-12': !targetAdjustmentKey, 'col-sm-8': targetAdjustmentKey }"
              >
                <bc-atoms-input-group
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.group.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.group.description'|translate}}"
                  [required]="true"
                  [state]="orderGroupControl.status"
                  [stateInput]="orderGroupControl.errors"
                  [stateTrigger]="orderGroupControl.invalid && (orderGroupControl.dirty)"
                >
                  <bc-atoms-typeahead
                    id="orderGroup"
                    name="orderGroup"
                    title="{{'order.fulfillment.groups.adjustments.fields.group.description'|translate}}"
                    placeholder="{{'actions.selectType'|translate:{ type: ('order.fulfillment.groups.adjustments.fields.group.title'|translate) } }}"
                    display="block"
                    labelKey="label"
                    iconKey="type"
                    size="small"
                    [required]="true"
                    [disabled]="isLoading"
                    [options]="groupOptions|async"
                    [(model)]="adjustment.group"
                    [(ngModel)]="adjustment.group"
                    #orderGroupControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                  </bc-atoms-typeahead>
                </bc-atoms-input-group>
              </div>
              <div class="col-sm-12" [hidden]="targetAdjustmentKey">
                <hr />
              </div>
              <!--Fabrication Time-->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'labour'"
              >
                <bc-atoms-input-group
                  labelIcon="time"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.fabrication.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.fabrication.description'|translate}}"
                  [required]="false"
                  [state]="fabricationControl.status"
                  [stateInput]="fabricationControl.errors"
                  [stateTrigger]="fabricationControl.invalid && (fabricationControl.dirty)"
                >
                  <bc-atoms-input
                    id="orderFabrication"
                    name="orderFabrication"
                    title="{{'order.fulfillment.groups.adjustments.fields.fabrication.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.fabrication.title'|translate}}"
                    size="small"
                    type="number"
                    [required]="false"
                    [disabled]="isLoading"
                    [(model)]="adjustment.shopLabour.value"
                    [(ngModel)]="adjustment.shopLabour.value"
                    #fabricationControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                    <div suffix-content>{{'labels.hours'|translate}}</div>
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Weight-->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'weight'"
              >
                <bc-atoms-input-group
                  labelIcon="weight"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.weight.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.weight.description'|translate}}"
                  [required]="false"
                  [state]="weightControl.status"
                  [stateInput]="weightControl.errors"
                  [stateTrigger]="weightControl.invalid && (weightControl.dirty)"
                >
                  <bc-atoms-input
                    id="orderWeight"
                    name="orderWeight"
                    title="{{'order.fulfillment.groups.adjustments.fields.weight.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.weight.title'|translate}}"
                    size="small"
                    type="number"
                    [required]="false"
                    [disabled]="isLoading"
                    [(model)]="adjustment.weight.value"
                    [(ngModel)]="adjustment.weight.value"
                    #weightControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                    <div suffix-content>
                      {{wdLocalSharedFunctions.translationKeys.weightUnit|translate}}
                    </div>
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Cost  -->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'cost'"
              >
                <bc-atoms-input-group
                  labelIcon="reimbursements"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.cost.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.cost.description'|translate}}"
                  [required]="false"
                  [state]="costControl.status"
                  [stateInput]="costControl.errors"
                  [stateTrigger]="costControl.invalid && (costControl.dirty)"
                >
                  <bc-atoms-input
                    id="orderCost"
                    name="orderCost"
                    title="{{'order.fulfillment.groups.adjustments.fields.cost.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.cost.title'|translate}}"
                    size="small"
                    type="number"
                    [required]="false"
                    [disabled]="isLoading"
                    [(model)]="adjustment.cost.value"
                    [(ngModel)]="adjustment.cost.value"
                    #costControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                    <div prefix-content>
                      {{wdLocalSharedFunctions.translationKeys.currencySymbol|translate}}
                    </div>
                    <div suffix-content>
                      {{wdLocalSharedFunctions.units.currency}}
                    </div>
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Price-->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'price'"
              >
                <bc-atoms-input-group
                  labelIcon="reimbursements"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.price.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.price.title'|translate}}"
                  [required]="false"
                  [state]="priceControl.status"
                  [stateInput]="priceControl.errors"
                  [stateTrigger]="priceControl.invalid && (priceControl.dirty)"
                >
                  <bc-atoms-input
                    id="orderPrice"
                    name="orderPrice"
                    title="{{'order.fulfillment.groups.adjustments.fields.price.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.price.title'|translate}}"
                    size="small"
                    type="number"
                    [required]="false"
                    [disabled]="isLoading"
                    [(model)]="adjustment.price.value"
                    [(ngModel)]="adjustment.price.value"
                    #priceControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                    <div prefix-content>
                      {{wdLocalSharedFunctions.translationKeys.currencySymbol|translate}}
                    </div>
                    <div suffix-content>
                      {{wdLocalSharedFunctions.units.currency}}
                    </div>
                  </bc-atoms-input>
                </bc-atoms-input-group>
              </div>
              <!--Material-->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'material'"
              >
                <bc-atoms-input-group
                  labelIcon="materialGauge"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.material.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.material.description'|translate}}"
                  [required]="false"
                  [state]="materialControl.status"
                  [stateInput]="materialControl.errors"
                  [stateTrigger]="materialControl.invalid && (materialControl.dirty)"
                >
                  <bc-atoms-typeahead
                    id="orderMaterial"
                    name="orderMaterial"
                    title="{{'order.fulfillment.groups.adjustments.fields.material.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.material.title'|translate}}"
                    labelKey="label"
                    size="small"
                    [canClear]="true"
                    [disabled]="isLoading"
                    [options]="materialOptions|async"
                    [(model)]="adjustment.material"
                    [(ngModel)]="adjustment.material"
                    #materialControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                  </bc-atoms-typeahead>
                </bc-atoms-input-group>
              </div>
              <!--Gauge-->
              <div
                [ngClass]="{ 'col-sm-6': !targetAdjustmentKey, 'col-sm-4': targetAdjustmentKey }"
                [hidden]="targetAdjustmentKey && targetAdjustmentKey !== 'gauge'"
              >
                <bc-atoms-input-group
                  labelIcon="materialGauge"
                  labelTitle="{{'order.fulfillment.groups.adjustments.fields.gauge.title'|translate}}"
                  labelDescription="{{'order.fulfillment.groups.adjustments.fields.gauge.description'|translate}}"
                  [required]="false"
                  [state]="gaugeControl.status"
                  [stateInput]="gaugeControl.errors"
                  [stateTrigger]="gaugeControl.invalid && (gaugeControl.dirty)"
                >
                  <bc-atoms-typeahead
                    id="orderGauge"
                    name="orderGauge"
                    title="{{'order.fulfillment.groups.adjustments.fields.gauge.description'|translate}}"
                    placeholder="{{'order.fulfillment.groups.adjustments.fields.gauge.title'|translate}}"
                    labelKey="value"
                    size="small"
                    [canClear]="true"
                    [disabled]="isLoading"
                    [options]="gaugeOptions|async"
                    [(model)]="adjustment.gauge"
                    [(ngModel)]="adjustment.gauge"
                    #gaugeControl="ngModel"
                    (modelChange)="checkForChanges()"
                  >
                  </bc-atoms-typeahead>
                </bc-atoms-input-group>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--Dialog Actions-->
    <div footer-content>
      <!--Buttons-->
      <div class="buttons-container">
        <div class="right-buttons">
          <!--Cancel/Close -->
          <bc-atoms-button
            [label]="('actions.cancel'|translate)"
            [title]="('actions.cancel'|translate)"
            [disabled]="isLoading"
            type="default"
            icon="cancel"
            display="block"
            size="small"
            (onButtonClicked)="onDismiss()"
          >
          </bc-atoms-button>
          <!--Save-->
          <bc-atoms-button
            [label]="('actions.save'|translate)"
            [title]="('actions.save'|translate)"
            [loading]="isLoading"
            [disabled]="isLoading || !isChanges || !adjustmentsForm.form.valid"
            type="success"
            icon="ok"
            size="small"
            (onButtonClicked)="onSubmit(adjustment)"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
  </bc-templates-modal-layout>
</div>
